import { render } from "./B2bFiltersDeliveryNotesEmit.vue?vue&type=template&id=19793910&scoped=true&lang=pug"
import script from "./B2bFiltersDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bFiltersDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bFiltersDeliveryNotesEmit.vue?vue&type=style&index=0&id=19793910&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19793910"]])

export default __exports__